import React from "react";
import { TFunction } from "i18next";
import { PlusIcon } from "@aureskonnect/react-ui";
import classnames from "classnames";

import ErrorToast from "@components/Common/ErrorTost";
import { CustomMainColorIconButton } from "@components/Common/CustomMainColorIconButton";
import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";
import { CESAR_LOYALTY } from "@constants/index";

import { ActionColumnWrapper } from "./ActionColumnWrapper";

type Props = {
    modify: boolean;
    oneShop: boolean;
    isEdited: boolean;
    isLoading: boolean;
    isAddFidelityClicked: boolean;
    setIsAddFidelityClicked: React.Dispatch<React.SetStateAction<boolean>>;
    isFidelityArchived: boolean;
    setIsFidelityArchived: React.Dispatch<React.SetStateAction<boolean>>;
    isModalOpened: boolean;
    setIsModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
    setIsModalOpenedSupport: React.Dispatch<React.SetStateAction<boolean>>;
    setIsInInitializationModalOpened: React.Dispatch<
        React.SetStateAction<boolean>
    >;
    setLocalFilterActive: React.Dispatch<React.SetStateAction<boolean>>;
    setFidelity: React.Dispatch<
        React.SetStateAction<FidelityRow | FidelityRow[] | undefined>
    >;
    setFidelityChoiceIndex: React.Dispatch<React.SetStateAction<number>>;
    setDataIsUpdated: React.Dispatch<React.SetStateAction<boolean | number>>;
    fidelity: FidelityRow[];
    fidelityData: FidelityDataTable & { data?: FidelityRow[] };
    selectedRows: FidelityRow[];
    setLimit: React.Dispatch<React.SetStateAction<number>>;
    t: TFunction;
};

export default function TableToolbar(props: Props) {
    const {
        modify,
        oneShop,
        isEdited,
        isLoading,
        isAddFidelityClicked,
        setIsAddFidelityClicked,
        isFidelityArchived,
        setIsFidelityArchived,
        isModalOpened,
        setIsModalOpened,
        setIsModalOpenedSupport,
        setIsInInitializationModalOpened,
        setLocalFilterActive,
        setFidelity,
        setFidelityChoiceIndex,
        setDataIsUpdated,
        fidelity,
        fidelityData,
        selectedRows,
        setLimit,
        t,
    } = props;

    const fidelityRows: FidelityRow[] = Array.isArray(fidelityData?.data)
        ? fidelityData.data
        : [];
    const cannotAddInFranchiseView =
        fidelityRows.length > 0 &&
        (oneShop ||
            (!oneShop &&
                fidelityRows.some(
                    (el: FidelityRow) =>
                        el.fidelityChoiceIndex !== CESAR_LOYALTY
                )));

    const openAddForm = () => {
        setFidelity([]);
        if (cannotAddInFranchiseView) {
            ErrorToast(
                t(
                    oneShop
                        ? "Attention, a shop cannot have more than one setting fidelity"
                        : "Attention, a franchise cannot have more than one setting fidelity"
                )
            );
        } else {
            setFidelityChoiceIndex(0);
            setIsAddFidelityClicked(!isAddFidelityClicked);
        }
        setLocalFilterActive(false);
    };

    const resetAddForm = () => {
        if (isEdited === true) setIsInInitializationModalOpened(true);
    };

    return (
        <React.Fragment>
            {modify === true ? (
                <>
                    {!isAddFidelityClicked ? (
                        <div className="d-flex justify-content-start align-items-center ml-2">
                            <span
                                data-testid="fidelity-franchise-add-button"
                                onClick={openAddForm}
                                className={classnames(
                                    "w-100 ml-3 cmn_btn_openForm",
                                    {
                                        "not-allowed-icon__clz":
                                            isFidelityArchived || isLoading,
                                    }
                                )}
                            >
                                <CustomMainColorButtonWithIcon
                                    icon="PlusIcon"
                                    iconPosition="left"
                                    rounded
                                    variant="primary"
                                >
                                    {t("Add fidelity")}
                                </CustomMainColorButtonWithIcon>
                            </span>
                        </div>
                    ) : (
                        <div className="d-flex justify-content-start">
                            <CustomMainColorIconButton
                                data-testid="fidelity-franchise-reset-button"
                                icon="PlusIcon"
                                className="fed_btn_FRreset"
                                rounded
                                disabled={fidelity.length > 0}
                                onClick={resetAddForm}
                            >
                                <PlusIcon height={20} width={20} fill="white" />
                            </CustomMainColorIconButton>
                        </div>
                    )}
                </>
            ) : null}
            <ActionColumnWrapper
                selectedRows={selectedRows}
                setDataIsUpdated={setDataIsUpdated}
                setIsModalOpened={setIsModalOpened}
                isModalOpened={isModalOpened}
                isFidelityArchived={isFidelityArchived}
                setIsFidelityArchived={setIsFidelityArchived}
                setIsAddFidelityClicked={setIsAddFidelityClicked}
                setIsModalOpenedSupport={setIsModalOpenedSupport}
                setLimit={setLimit}
            />
        </React.Fragment>
    );
}
